import { formatPrismicData } from '@monofront/business/utils';
import { IMultiSliderCalculator } from '@monofront/design-system/organisms/MultiSliderCalculator';
import { PrismicLinkContext } from '@monofront/types';
import { MultiSliderCalculatorProps } from './types';

export const mapSliderCalculator = ({
  prismicContent,
}: {
  prismicContent: MultiSliderCalculatorProps;
}): IMultiSliderCalculator => {
  const formattedData = formatPrismicData(prismicContent);

  const {
    image,
    alt,
    title,
    tooltipText,
    firstSliderText,
    secondSliderText,
    firstSliderValues,
    secondSliderValues,
    firstSliderSelectedOption,
    secondSliderSelectedOption,
    calculatorValues,
    legendValues,
    initialText,
    editedText,
    totalPriceDescription,
    ctaLabel,
    ctaLink,
    ctaText,
  } = formattedData.primary;

  return {
    primary: {
      image,
      alt,
      title,
      tooltipText,
      firstSliderText,
      secondSliderText,
      firstSliderValues,
      secondSliderValues,
      firstSliderSelectedOption,
      secondSliderSelectedOption,
      calculatorValues,
      legendValues,
      initialText,
      editedText,
      totalPriceDescription,
      ctaLabel,
      ctaLink,
      ctaText,
    },
    withCheatSheet: false,
    context: PrismicLinkContext.SHOP,
  };
};
